export const getWeekendsOfMonth = (year: number, month: number) => {
  const weekends = [];
  const date = new Date(year, month, 1);
  while (date.getMonth() === month) {
    if (date.getDay() === 6 || date.getDay() === 0) {
      weekends.push(new Date(year, month, date.getDate()));
    }
    date.setDate(date.getDate() + 1);
  }
  return weekends;
};

export const getWeekendsOfYear = (year: number) => {
  const weekends = [];

  for (let month = 0; month < 12; month++) {
    const monthWeekends = getWeekendsOfMonth(year, month);

    weekends.push(...monthWeekends);
  }

  return weekends;
};
